import { useState } from 'react';
import { sendContact } from '../api/api';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaPaperPlane, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import SocialLinks from '../components/SocialLinks';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      await sendContact(form);
      setStatus('success');
      setForm({ name: '', email: '', message: '' });
    } catch {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="page-title">
        <h2>Get In <span>Touch</span></h2>
        <p>We'd love to hear from you</p>
        <div className="accent-line" />
      </div>

      <div className="contact-grid" style={{ marginTop: '3rem' }}>
        {/* Form */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <h3 style={{ color: 'var(--blue)', fontWeight: 700, marginBottom: '0.5rem' }}>Send a Message</h3>
          <div className="form-group">
            <label>Full Name</label>
            <input name="name" value={form.name} onChange={handleChange} placeholder="Your name" required />
          </div>
          <div className="form-group">
            <label>Email Address</label>
            <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="your@email.com" required />
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea name="message" value={form.message} onChange={handleChange} placeholder="Write your message..." required />
          </div>
          <button type="submit" className="btn-primary" disabled={loading} style={{ opacity: loading ? 0.7 : 1, display: 'flex', alignItems: 'center', gap: '0.5rem', justifyContent: 'center' }}>
            {loading ? 'Sending...' : <><FaPaperPlane size={14} /> Send Message</>}
          </button>
          {status === 'success' && <div className="alert alert-success" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><FaCheckCircle size={16} /> Message sent! We'll get back to you soon.</div>}
          {status === 'error' && <div className="alert alert-error" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><FaExclamationTriangle size={16} /> Failed to send. Please try again or call us directly.</div>}
        </form>

        {/* Info */}
        <div className="contact-info">
          <h3 style={{ color: 'var(--blue)', fontWeight: 700, marginBottom: '0.5rem' }}>Contact Information</h3>
          {[
            { icon: <FaPhone size={20} />, title: 'Phone', lines: ['+91 8077623711', '+91 7417652434'] },
            { icon: <FaEnvelope size={20} />, title: 'Email', lines: ['sbsinstitute711@gmail.com',] },
            { icon: <FaMapMarkerAlt size={20} />, title: 'Address', lines: ['Main Road, Near ARTO, Muzaffarnagar, UP – 251002, India'] },
            { icon: <FaClock size={20} />, title: 'Timings', lines: ['Mon–Sat: 8:00 AM – 8:00 PM', 'Sunday: 10:00 AM – 2:00 PM'] },
          ].map(({ icon, title, lines }) => (
            <div className="contact-item" key={title}>
              <span className="contact-item-icon" style={{ color: 'var(--blue)' }}>{icon}</span>
              <div>
                <h4>{title}</h4>
                {lines.map(l => <p key={l}>{l}</p>)}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Social Media Section */}
      <div style={{
        marginTop: '3rem',
        background: 'var(--white)',
        border: '1px solid var(--border)',
        borderRadius: 14,
        padding: '2rem',
        textAlign: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      }}>
        <h3 style={{ color: 'var(--blue)', fontWeight: 700, marginBottom: '0.5rem', fontSize: '1.1rem' }}>
          Connect With Us
        </h3>
        <p style={{ color: 'var(--gray)', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
          Follow us on social media for updates, tips, and educational content
        </p>
        <SocialLinks variant="contact" size={20} />
      </div>
    </div>
  );
}
